export const VsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="48"
      viewBox="0 0 34 48"
      fill="none"
    >
      <g filter="url(#filter0_dd_2641_21269)">
        <path
          d="M11.6914 34.0007C12.6313 31.689 13.571 29.3769 14.5107 27.0652H15.6709C15.6041 27.2053 15.5382 27.3438 15.4707 27.4851C13.9561 30.6569 12.4414 33.8289 10.9268 37.0007C10.8435 37.1751 10.7571 37.3557 10.6738 37.53L9.96484 37.2166C10.0375 37.0379 10.113 36.8521 10.1855 36.6736C11.4872 33.4718 12.7892 30.2671 14.0908 27.0652H14.5098C13.5701 29.3767 12.6311 31.689 11.6914 34.0007ZM20.6826 19.4138C23.2841 19.4139 24.377 20.2667 24.377 22.1267V23.3972H22.3447V21.0574H19.0195V23.7078L24.377 25.8005V28.2498C24.3769 30.1251 23.284 30.9625 20.6826 30.9626C18.0963 30.9626 17.003 30.1098 17.0029 28.2498V26.9783H19.0195V29.3035H22.3447V26.6687L17.0029 24.5759V22.1267C17.0029 20.2511 18.0962 19.4138 20.6826 19.4138ZM13.252 23.3611C13.3598 23.8705 13.4374 24.3027 13.499 24.6423H13.8838L13.9922 24.1023C14.0538 23.7782 14.0993 23.5309 14.1455 23.3611L15.9023 14.9626H18.0742L15.4863 26.2322H11.8965L9.30859 14.9626H11.4961L13.252 23.3611ZM24.2275 8.84644C24.155 9.02489 24.0793 9.21008 24.0068 9.38843C22.7053 12.5901 21.4032 15.795 20.1016 18.9968H18.5215C18.5882 18.8567 18.6542 18.7181 18.7217 18.5769C20.2363 15.405 21.751 12.2331 23.2656 9.06128C23.3488 8.88702 23.4353 8.70723 23.5186 8.53296L24.2275 8.84644Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_2641_21269"
          x="1.43051e-05"
          y="9.44138e-05"
          width="33.6855"
          height="47.6142"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.775715" />
          <feGaussianBlur stdDeviation="0.775715" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2641_21269"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.775715" />
          <feGaussianBlur stdDeviation="4.65429" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2641_21269"
            result="effect2_dropShadow_2641_21269"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2641_21269"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
